import React from 'react';
import { Box, Chip } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const orders = [
    { id: 0, value: '', label: '전체', color: 'default' },
    { id: 1, value: 'usrNoAsc', label: '사번', icon: <ArrowDropUpIcon />, color: 'primary' },
    { id: 2, value: 'usrNoDesc', label: '사번', icon: <ArrowDropDownIcon />, color: 'success' },
    { id: 1, value: 'gradeNmAsc', label: '직급', icon: <ArrowDropUpIcon />, color: 'secondary' },
    { id: 2, value: 'gradeNmDesc', label: '직급', icon: <ArrowDropDownIcon />, color: 'warning' },
]

const EmpOrdList = ({ orderName, onChangeOrder }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItem: 'center',
                m: 1,
            }}
        >
            <Box sx={{ mx: 1 }}>
                {orders && orders.map((st, index) => (
                    <Chip
                        sx={{ mr: 2 }}
                        key={index}
                        icon={st.icon ? st.icon : <CircleIcon />}
                        label={st.label}
                        variant={st.value === orderName ? 'contained' : 'outlined'}
                        color={st.color}
                        onClick={() => onChangeOrder(st.value)}
                    />
                ))}
            </Box>
        </Box>
    )
}

export default EmpOrdList